import { PrivyClientConfig } from '@privy-io/react-auth'
import { DEFAULT_CHAIN, SUPPORTED_CHAINS } from './chains'

export const privyConfig: PrivyClientConfig = {
  legal: {
    termsAndConditionsUrl: 'https://support.zora.co/en/articles/6383293-terms-of-service',
    privacyPolicyUrl: 'https://support.zora.co/en/articles/6383373-zora-privacy-policy',
  },
  embeddedWallets: {
    createOnLogin: 'users-without-wallets',
    requireUserPasswordOnCreate: false,
    showWalletUIs: false,
  },
  externalWallets: {
    coinbaseWallet: {
      connectionOptions: 'all',
    },
  },
  loginMethods: ['wallet', 'email'],
  appearance: {
    showWalletLoginFirst: true,
    logo: '/assets/zorb.png',
    accentColor: '#000000',
    walletList: [
      'detected_wallets',
      'coinbase_wallet',
      'phantom',
      'uniswap',
      'rainbow',
      'wallet_connect',
      'metamask',
    ],
    // @ts-expect-error hidden Privy feature to require users to click through for email input
    hideDirectWeb2Inputs: true,
  },
  defaultChain: DEFAULT_CHAIN,
  supportedChains: SUPPORTED_CHAINS,
}

export const PRIVY_API_URL =
  process.env.VERCEL_ENV === 'production' ? 'https://privy.zora.co' : undefined
export const PRIVY_APP_ID = process.env.NEXT_PUBLIC_PRIVY_APP_ID as string
export const PRIVY_CLIENT_ID = process.env.NEXT_PUBLIC_PRIVY_CLIENT_ID as string

if (!PRIVY_APP_ID || !PRIVY_CLIENT_ID) {
  throw new Error('Missing PRIVY_APP_ID or PRIVY_CLIENT_ID')
}
